<template>
  <v-row justify="center" v-if="item">
    <v-dialog v-model="show" width="500px">
      <v-card>
        <v-card-title style="justify-content: center">{{ $t('subOrder.statusHistory') }}</v-card-title>
        <v-card-text>
          <v-timeline dense>
            <v-timeline-item v-for="status in item.status_history" v-bind:key="status._id">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>{{ getStatusTranslation(status.label_status) }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ new Date(status.date) | moment('DD/MM/YYYY HH:mm:ss') }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="status.username">
                    {{ $t('user.username') }}: {{ status.username }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="status.email">
                    {{ $t('user.email') }} : {{ status.email }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap" v-if="status.status_comment">
                    {{ $t('components.modalHistory.comment') }} :
                    {{ getStatusCommentTranslation(status.status_comment) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-btn color="secondary" tile block @click="close">{{ $t('subOrder.return') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name: 'StatusHistoryDialog',
    data() {
      return {
        status: [
          { text: this.$t('order.waiting'), value: 'waiting' },
          { text: this.$t('order.confirmed'), value: 'confirmed' },
          { text: this.$t('order.partiallyConfirmed'), value: 'partially_confirmed' },
          { text: this.$t('order.toPickup'), value: 'to_pickup' },
          { text: this.$t('order.waitingCarrier'), value: 'waiting_carrier' },
          { text: this.$t('order.shippingInProgress'), value: 'shipping_in_progress' },
          { text: this.$t('order.partialShippingInProgress'), value: 'partial_shipping_in_progress' },
          { text: this.$t('order.delivered'), value: 'delivered' },
          { text: this.$t('order.deliveredPartially'), value: 'partially_delivered' },
          { text: this.$t('order.cancelled'), value: 'cancelled' },
          { text: this.$t('return.waiting'), value: 'waiting' },
          { text: this.$t('return.waitingProductsReceipt'), value: 'waiting_products_receipt' },
          { text: this.$t('return.productsReceived'), value: 'products_received' },
          { text: this.$t('return.productsPartiallyReceived'), value: 'products_partially_received' },
          { text: this.$t('return.finished'), value: 'finished' },
          { text: this.$t('return.cancelled'), value: 'cancelled' },
          { text: this.$t('subOrder.waitingAllocation'), value: 'waiting_allocation' },
          { text: this.$t('order.waitingPayment'), value: 'waiting_payment' },
          { text: this.$t('order.blocked'), value: 'blocked' },
        ],
        statusComment: [
          {
            text: this.$t('order.pickupLocationNotFoundOrDefinitelyClosed'),
            value: 'pickup_location_not_found_or_definitely_closed',
          },
          { text: this.$t('order.missingPickupLocationInData'), value: 'missing_pickup_location_in_data' },
          {
            text: this.$t('order.sourceLocationNotFoundOrDefinitelyClosed'),
            value: 'source_location_not_found_or_definitely_closed',
          },
          { text: this.$t('order.sourceAndPickupLocationsMissing'), value: 'source_and_pickup_locations_missing' },
          { text: this.$t('order.sourceOrPickupLocationMissing'), value: 'source_or_pickup_location_missing' },
          { text: this.$t('order.sourceLocationIsMissing'), value: 'source_location_is_missing' },
          { text: this.$t('order.unknownOrUnhandledType'), value: 'unknown_or_unhandled_type' },
          { text: this.$t('order.serviceNotActive'), value: 'service_not_active' },
          {
            text: this.$t('order.pickupLocationIdSentForNonStoreDeliveryOrder'),
            value: 'pickup_location_id_sent_for_non_store_delivery_order',
          },
          { text: this.$t('order.workflowNotActivatedOrNotFound'), value: 'workflow_not_activated_or_not_found' },
          { text: this.$t('order.sourceLocationIsNotFound'), value: 'source_location_is_not_found' },
          {
            text: this.$t('order.sourceLocationIsDefinitivelyClosed'),
            value: 'source_location_is_definitively_closed',
          },
          { text: this.$t('order.serviceNotActiveOnPickupLocation'), value: 'service_not_active_on_pickup_location' },
          { text: this.$t('order.serviceNotActiveOnSourceLocation'), value: 'service_not_active_on_source_location' },
          { text: this.$t('order.storeCouldNotProcessInTime'), value: 'store_could_not_process_in_time' },
          // deprecated and replaced by 'store_could_not_process_in_time' but kept for backwards compatibility
          { text: this.$t('order.storeCouldntProcessInTime'), value: 'store_couldnt_process_in_time' },
          { text: this.$t('order.duplicatedItem'), value: 'duplicated_item' },
        ],
      }
    },
    props: {
      item: Object,
      value: {
        required: true,
      },
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
    methods: {
      getStatusTranslation: function (statusValue) {
        let status = this.status.find((status) => status.value === statusValue)
        if (status) {
          return status.text
        } else return statusValue
      },
      close: function () {
        this.$emit('close')
      },
      getStatusCommentTranslation: function (statusCommentValue) {
        let statusComment = this.statusComment.find((statusComment) => statusComment.value === statusCommentValue)
        if (statusComment) {
          return statusComment.text
        } else return statusCommentValue
      },
    },
  }
</script>
